import React, { useState } from "react";

interface ConfirmDeleteButtonProps {
  onConfirm: () => void;
  text?: string;
}

export const ConfirmDeleteButton: React.FC<ConfirmDeleteButtonProps> = ({
  onConfirm,
  text = "¿Eliminar nota?",
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const toggleConfirm = () => setShowConfirm((prev) => !prev);

  return (
    <div className="confirm-delete-container">
      {/* Botón principal */}
      <button
        type="button"
        className="btn btn-rounded btn-rounded-transparent tippy confirm-delete-btn"
        data-tippy-content="Eliminar selección y nota"
        aria-label="Eliminar selección y nota"
        onClick={toggleConfirm}
      >
        <span className="btn__icon">
          <i className="icon icon-vpro-sys-delete"></i>
        </span>
      </button>

      {/* Menú de confirmación */}
      <div className={`confirm-delete-menu ${showConfirm ? "open" : "closed"}`}>
        <span className="confirm-delete-text">{text}</span>
        <button
          className="confirm-delete-check"
          onClick={() => {
            onConfirm();
            toggleConfirm();
          }}
          aria-label="Confirmar eliminación"
        >
          <i className="icon icon-vpro-oc-check"></i>
        </button>
        <button
          className="confirm-delete-cancel"
          onClick={toggleConfirm}
          aria-label="Cancelar eliminación"
        >
          <i className="icon icon-vpro-oc-close"></i>
        </button>
      </div>
    </div>
  );
};
